module.exports = __webpack_public_path__ + "img/Impact definition-Impact characterisation.47202263.svg";